import { getReasonFromErrorCode } from "@gymflow/common/lib/helpers/getReasonFromErrorCode";
import { useTranslation } from "react-i18next";

import { ConfirmModal } from "../../templates";

type NotAvailableModalProps = {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  errorCode: string;
};

export const NotAvailableModal = ({
  onConfirm,
  onCancel,
  errorCode,
}: NotAvailableModalProps) => {
  const { t } = useTranslation();

  const reason = getReasonFromErrorCode(errorCode);

  return (
    <ConfirmModal
      onConfirm={onConfirm}
      onCancel={onCancel}
      title={t(`components.notAvailableModal.${reason}.title`)}
    >
      {t(`components.notAvailableModal.${reason}.description`)}
    </ConfirmModal>
  );
};
